"use client";

import dynamic from "next/dynamic";

export const SoundEffectsAPIWrapper = dynamic(() => import("./SoundEffectsAPI").then(mod => mod.SoundEffectsAPI));
